const BanzaFileDropAreaPresets = {
  BanzaFileDropArea: {
    slots: {
      icon: {
        attrs: {
          icon: "lets-icons:upload-duotone",
          size: "100px",
          color: "primary"
        }
      },
      text: {
        class: "text-secondary text-center",
        attrs: {
          textLcz: "base.labels.drop_area"
        }
      },
      link: {
        class: "text-primary font-weight-bold",
        attrs: {
          textLcz: "base.labels.choose_file",
          density: "compact",
          variant: "text",
          size: "default"
        }
      }
    },
    presets: {
      compact: {
        class: "variant--compact",
        slots: {
          icon: {
            attrs: {
              icon: "lets-icons:upload-duotone",
              size: "24px",
              color: "primary"
            }
          },
          text: {
            class: "text-secondary",
            attrs: {
              textLcz: "base.labels.drag_file_here"
            }
          },
          link: {
            class: "text-primary font-weight-bold",
            attrs: {
              textLcz: "base.labels.click_to_upload",
              density: "compact",
              variant: "text",
              size: "default"
            }
          }
        }
      }
    }
  }
};
export {
  BanzaFileDropAreaPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
